import { render, staticRenderFns } from "./widget-rating.vue?vue&type=template&id=aa2f718c&scoped=true&"
import script from "./widget-rating.vue?vue&type=script&lang=js&"
export * from "./widget-rating.vue?vue&type=script&lang=js&"
import style0 from "./widget-rating.vue?vue&type=style&index=0&id=aa2f718c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2f718c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VFadeTransition,VIcon,VSlider})
